import * as Types from '../../../../../graphql.generated';

export type SocialSignInGoogleMutationVariables = Types.Exact<{
    accessToken: Types.Scalars['String'];
    rememberMe: Types.Scalars['Boolean'];
}>;

export type SocialSignInGoogleMutation = { __typename?: 'Mutation' } & {
    socialSignInGoogle?: Types.Maybe<
        { __typename?: 'SocialSignInGoogleResponse' } & Pick<
            Types.SocialSignInGoogleResponse,
            'success'
        >
    >;
};

export const SocialSignInGoogleDocument = `
    mutation socialSignInGoogle($accessToken: String!, $rememberMe: Boolean!) {
  socialSignInGoogle(accessToken: $accessToken, rememberMe: $rememberMe) {
    success
  }
}
    `;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {
        socialSignInGoogle(
            variables: SocialSignInGoogleMutationVariables,
            options?: C
        ): Promise<SocialSignInGoogleMutation> {
            return requester<
                SocialSignInGoogleMutation,
                SocialSignInGoogleMutationVariables
            >(SocialSignInGoogleDocument, variables, options);
        }
    };
}
export type Sdk = ReturnType<typeof getSdk>;
